import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "team-projects" }
const _hoisted_2 = {
  class: "team-info-tab-row d-flex flex-wrap",
  id: "teams-tab-row"
}
const _hoisted_3 = {
  class: "nav nav-pills flex-nowrap flex-grow-1",
  role: "tablist"
}
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "flex-fill d-flex justify-content-end" }
const _hoisted_6 = { class: "team-info-body pt-3" }
const _hoisted_7 = {
  id: "project-list",
  class: "list-group",
  role: "tablist"
}
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_item = _resolveComponent("project-item")!
  const _component_project_lock_modal = _resolveComponent("project-lock-modal")!
  const _component_project_remove_modal = _resolveComponent("project-remove-modal")!
  const _component_project_new_modal = _resolveComponent("project-new-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h4", { class: "invisible" }, "Projects")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("li", { class: "nav-item" }, [
          _createElementVNode("a", {
            class: "nav-link active",
            href: "#",
            "data-toggle": "pill",
            "aria-selected": "true"
          }, "Projects")
        ], -1)),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$parent.showTeamMembers && _ctx.$parent.showTeamMembers(...args)))
          }, "People")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass([{'d-none': !_ctx.hasProjects()}, "btn btn-attention btn-new-item btn-new-project"]),
          "data-target": "#project-new-modal",
          "data-toggle": "modal"
        }, " New Project ", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass([{'d-none': _ctx.hasProjects()}, "w-100"])
      }, [...(_cache[2] || (_cache[2] = [
        _createStaticVNode("<div class=\"justify-content-center\" data-v-5736b917><div class=\"text-center\" data-v-5736b917><i class=\"fa fa-5x fa-tasks mt-5 mb-2\" data-v-5736b917></i><br data-v-5736b917><button class=\"btn btn-attention btn-new-item btn-new-project\" data-target=\"#project-new-modal\" data-toggle=\"modal\" data-v-5736b917> New Project </button></div></div><div class=\"mt-3 justify-content-center\" data-v-5736b917><p class=\"text-muted text-center\" data-v-5736b917>Project is a file which you work with in desktop GanttProject. All team members will have read-write access to projects owned by the team.<br data-v-5736b917><a href=\"https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud\" target=\"_blank\" data-v-5736b917>Learn more</a></p></div>", 2)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{'d-none': !_ctx.hasProjects()}, "w-100"])
      }, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
            return (_openBlock(), _createElementBlock("div", _mergeProps({
              class: "project-item list-group-item list-group-item-action d-flex",
              onClick: ($event: any) => (_ctx.onProjectSelected(p)),
              key: p.refid
            }, { ref_for: true }, {'data-project': p.refid}), [
              _createVNode(_component_project_item, { project: p }, null, 8, ["project"])
            ], 16, _hoisted_8))
          }), 128))
        ])
      ], 2)
    ]),
    _createVNode(_component_project_lock_modal, {
      id: "project-lock-modal",
      team: _ctx.team_,
      project: _ctx.project
    }, null, 8, ["team", "project"]),
    _createVNode(_component_project_remove_modal, {
      id: "project-remove-modal",
      team: _ctx.team_,
      project: _ctx.project
    }, null, 8, ["team", "project"]),
    _createVNode(_component_project_new_modal, {
      id: "project-new-modal",
      team: _ctx.team_
    }, null, 8, ["team"])
  ]))
}